import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { useNavigate, Link } from 'react-router-dom';
import $ from 'jquery';
import 'jquery-confirm';
import Spinner from '../Spinner';
import api from '../../api/axiosInstance';

const FormCategories = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [categoryName, setCategoryName] = useState('');
    const [description, setDescription] = useState('');
       const [blocked, setBlocked] = useState(false);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await api.get('/Administration/ViewFormCategories');
                setCategories(response.data);
            } catch (error) {
                console.error("Error fetching categories:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCategories();
    }, []);

useEffect(() => {
    let table;
    if (!loading && categories.length > 0) {
        // Initialize DataTables
        table = window.$('#example1').DataTable({
            responsive: true,
            autoWidth: false,                           
            searching: true,
            ordering: true,                                                                                                                                 
            pageLength: 10,
            lengthChange: false, // Fixed typo: was 'lenghtChange'
            paging: true,
            info: true,
            destroy: true, // 💡 Important: allows re-initialization
        });                                                                                                                                                                                                                                   
    }                                                                                                                                                                                                                                                    

    // 💡 CLEANUP: This prevents the "e.push" error by destroying 
    // the table instance when the component updates or unmounts.                                                                                                                                                                                                                                                                                                                                                                                                                               
    return () => {
        if (table) {
            table.destroy();
        }
    };
}, [loading, categories]); // Added categories so it refreshes when data is added/deleted// Added 'categories' as a dependency so DataTable re-initializes when data changes                                                                                                                                                                                                                                                    

    const deleteCategory = (categoryId) => {    
        $.confirm({
            title: 'Confirm Deletion',
            content: 'Do you really want to delete this?',
            buttons: {
                cancel: {                                                                                                                                                                                                                      
                    text: 'Cancel',
                    btnClass: 'btn-red',
                    action: function () {
                        // Do nothing on cancel
                    }
                },
                confirm: {
                    text: 'Yes, delete it!',
                    btnClass: 'btn-green',
                    action: async function () {
                        try {
                            setBlocked(true);
                            const response = await api.delete(`/Administration/DeleteFormCategory/${categoryId}`);

                            // Success alert
                            $.alert({
                                title: 'Success!',
                                content: response.data,
                                type: 'green',
                                buttons: {
                                    okay: {
                                        text: 'Ok',
                                        btnClass: 'btn-green',
                                        action: function () {
                                            // Refresh the category data after deletion
                                            api.get(`/Administration/ViewFormCategories`)
                                                .then(fetchResponse => {
                                                    setCategories(fetchResponse.data);
                                                });
                                                setBlocked(false);
                                        }
                                    }
                                }
                            });
                        } catch (error) {
                            if (error.response && error.response.status === 409) {
                                 setBlocked(false);
                                $.alert({
                                    title: 'Error!',
                                    content: error.response.data,
                                    type: 'red',
                                });
                            } else {
                                 setBlocked(false);                                                          
                                $.alert({
                                    title: 'Error!',
                                    content: 'Error deleting subcategory',
                                    type: 'red',
                                });
                            }
                        }
                    }
                }
            }
        });
    };
    const addCategory = async () => {
        // Validate input
        if (!categoryName || !description) {
            alert("Please fill in all fields.");
            return;
        }

        try {
            debugger;
            setBlocked(true);
            const response = await api.post('/Administration/AddFormCategory', {
                Name: categoryName,
                Description: description
            }
            );
            // Assuming the response contains the created category
           const response1 = await api.get('/Administration/ViewFormCategories');
            setCategories(response1.data);
            setCategoryName(''); // Reset input
            setDescription('');  // Reset input
            setBlocked(false);
            $.confirm({
                title: 'Success',
                content: 'Record saved successfully',
                type: 'green',
                buttons: {
                    okay: {
                        text: 'Ok',
                        btnClass: 'btn-green',
                        action: () => {
                            debugger;
                            // Close the modal
                            const modal = document.getElementById('modal-default');
                            modal.style.display = 'none'; // Close the modal
                            const backdrop = document.querySelector('.modal-backdrop');
                            if (backdrop) {
                                backdrop.remove();
                            }     
                        },
                    },
                },
            });
            // Close modal if using Bootstrap's modal
        } catch (error) {
            console.error("Error adding category:", error);
            alert("There was an error creating the category.");
        }
    };

     const backdropStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "rgba(0,0,0,0.2)", // light dark shade
  zIndex: 9998,
  cursor: "wait"  // cursor changes to loading
};

const overlayStyle = {
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "#222",
  padding: "30px 50px",
  borderRadius: "12px",
  zIndex: 9999,
  color: "#fff",
  fontSize: "22px",
  textAlign: "center",
  cursor: "wait" // cursor loading
};  
    return (
        <>
                            {blocked && (
  <>
    {/* FULL SCREEN BACKDROP THAT BLOCKS CLICKS */}
    <div style={backdropStyle}></div>

    {/* CENTER BOX */}
    <div style={overlayStyle}>
      <div className="spinner-border" role="status"></div>
      <div>Please wait…</div>
    </div>
  </>
)}
            <Helmet>
                <title>Form Categories</title>
                {/* Other meta tags can be added here */}
            </Helmet>
            <div>
                <div className="card card-success" style={{ marginTop: '0px' }}>

                    <div className="card-header"
                    //  style={{ display: 'flex', flexDirection: 'column' }}
                    >
                        <h3 className="card-title">Form Categories</h3>
                        {/* <div style={{ marginTop: '10px' }}>
                            <button
                                className='btn btn-success btn-default'
                                title='Add Category'
                                data-toggle="modal"
                                data-target="#modal-default">
                                <i className='fa fa-write'></i> New
                            </button>
                        </div> */}
                    </div>
                    <div className="card-body">

                        <div className="row">
                            <div className="col-sm-3">
                                <div style={{ marginBottom: '10px' }}>
                                    <button
                                        className='btn btn-success btn-sm'
                                        title='Add Category'
                                        data-toggle="modal"
                                        data-target="#modal-default">
                                        <i className='fa fa-write'></i> New
                                    </button>
                                </div>
                            </div>
                        </div>
                        {loading ? (
                            <Spinner /> // Use the Spinner component here
                        ) : (
                            <div className="col-sm-12">
                                <table id="example1" className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th width="40%">Name</th>
                                            <th width="37%">Description</th>
                                            <th width="15%">Created On</th>
                                            <th width="8%">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {categories.map(category => (
                                            <tr key={category.id}>
                                                <td>{category.name}</td>
                                                <td>{category.description}</td>
                                                <td>{new Date(category.createdOn).toLocaleDateString()}</td>
                                                <td>
                                                    <Link
                                                        to={`/editor/FormCategory/${category.id}`}
                                                        className='btn btn-xs btn-success'
                                                        title='View'
                                                    >
                                                        <i className='fa fa-eye'></i>
                                                    </Link>
                                                    &nbsp;&nbsp;
                                                    <button
                                                        className='btn btn-xs btn-danger'
                                                        onClick={() => deleteCategory(category.id)}
                                                        title='Delete'
                                                    >
                                                        <i className='fa fa-trash'></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th>Name</th>
                                            <th>Description</th>
                                            <th>Created On</th>
                                            <th>Action</th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>


                        )}
                    </div>
                </div>
            </div>
            <div className="modal fade" id="modal-default">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Add New Category</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>

                        <div className="modal-body">
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className="form-group">
                                        <label htmlFor="name">Form Category Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="name"
                                            maxLength={100}
                                            value={categoryName}
                                            onChange={(e) => setCategoryName(e.target.value)} // Update state on input change
                                        />
                                        <span id='spantxtFormCategoryName' className='field-validation-valid'></span>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className="form-group">
                                        <label htmlFor="description">Description</label>
                                        <textarea
                                            className="form-control"
                                            id="description"
                                            rows={4}
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)} // Update state on input change
                                        />
                                        <span id='spantxtDescription' className='field-validation-valid'></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="button" className="btn btn-default" data-dismiss="modal">Close</button>
                            <button type="button" className="btn btn-primary" onClick={addCategory}>Save changes</button>
                        </div>
                    </div>
                    {/* /.modal-content */}
                </div>
                {/* /.modal-dialog */}
            </div>
            {/* /.modal */}

        </>
    );
};

export default FormCategories;
